import { RouteObject } from 'react-router-dom';

import { AppNotFoundPage, MainLayout } from '@/components';

export const notFoundRoute: RouteObject = {
  element: <MainLayout />,
  children: [{ path: '*', element: <AppNotFoundPage /> }],
};
